export const resumeHtmlContent = (content: string) =>
  content
    .replace(/(<([^>]+)>)/gi, "")
    .split(" ")
    .reduce((acc, val, i) => (i <= 80 ? acc.concat(" " + val) : acc))
    .replace("&nbsp;", " ")
    .concat("...");
